import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiPost, apiDelete, apiGet, apiPut, baseUrl } from "../../../../service/apiService";


const initialState = {
  Loading: false,
  keralaAdmissionsList: [],
  japaneseApplication: {
    candidates: [],
  },
  pendingCount: 0,
  completedCount: 0,

};


export const addApplication = createAsyncThunk(
  'application/addApplication',
  async (param) => {
    try {
      const response = await apiPost('admission/kerala', param, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
);


export const udpateApplication = createAsyncThunk(
  'application/udpateApplication',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await apiPut(`admission/kerala/${id}`, formData);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getApplication = createAsyncThunk(
  'application/getApplication',
  async (params, { rejectWithValue }) => {
    try {
      const { page, perPage, search, status, management_status } = params;
      const response = await apiGet(`admission/kerala?page=${page}&per_page=${perPage}&search=${search}&status=${status}&management_status=${management_status}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);



export const deleteApplication = createAsyncThunk(
  'user/deleteApplication',
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiDelete(`admission/kerala/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error);

    }
  }
);

export const getJapaneseApplicationById = createAsyncThunk(
  'application/getJapaneseApplicationById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiGet(`admission/kerala?kerala_admission_id=${id}&resume_version=JP`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


const keralaAdmissionSlice = createSlice({
  name: 'keralaAdmission',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getApplication.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getApplication.fulfilled, (state, action) => {
        state.Loading = false;
        state.keralaAdmissionsList = action.payload;
        state.pendingCount = action.payload.pending;
        state.completedCount = action.payload.completed;
      })
      .addCase(getApplication.rejected, (state, action) => {
        state.Loading = false;
      }).addCase(getJapaneseApplicationById.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getJapaneseApplicationById.fulfilled, (state, action) => {
        state.Loading = false;
        state.japaneseApplication = action.payload;
      })
      .addCase(getJapaneseApplicationById.rejected, (state, action) => {
        state.Loading = false;
      })

  }
})


export default keralaAdmissionSlice.reducer;